module.exports = __webpack_public_path__ + "static/media/tiktok.0ff94ff7.svg";